//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'InfantHeartFailureGradingScale',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: '',
        data7: '',
        data8: ''
      },
      dataList1: [
        {name: '＞105', value: '0'},
        {name: '75-105', value: '1'},
        {name: '＜75', value: '2'}
      ],
      dataList2: [
        {name: '＜40', value: '0'},
        {name: '＞40', value: '1'}
      ],
      dataList3: [
        {value: '0', name: '＜50'},
        {value: '1', name: '50-60'},
        { value: '2', name: '＞60'}
      ],
      dataList4: [
        {name: '＜160', value: '0'},
        {name: '160-170', value: '1'},
        {name: '>170', value: '2'}
      ],
      dataList5: [
        {value: '0', name: '平顺'},
        {value: '1', name: '吸凹'},
        {value: '2', name: '困难'}
      ],
      dataList6: [
        {value: '0', name: '正常'},
        {value: '1', name: '不良'}
      ],
      dataList7: [
        {value: '0', name: '无'},
        {value: '1', name: '有'}
      ],
      dataList8: [
        {value: '0', name: '＜2'},
        {value: '1', name: '2-3'},
        {value: '2', name: '>3'}
      ],
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            result += form[key]
          }
        }
      }
      if (!flag) {
        return ''
      }

      if (result <= 2) {
        self.descTxt = '无心衰'
      } else if (result > 2 && result <= 6) {
        self.descTxt = '轻度心衰'
      } else if (result > 6 && result <= 9) {
        self.descTxt = '中度心衰'
      } else if (result >= 10) {
        self.descTxt = '重度心衰'
      }

      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/InfantHeartFailureGradingScale.vue